import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  return (
    <main className="grid min-h-screen place-items-center px-6">
      <div className="text-center">
        <p className="sig text-4xl text-cream">Nikita Kering'</p>
        <h1 className="mt-6 font-serif text-3xl">Page not found</h1>
        <Button asChild className="mt-6">
          <Link to="/">Back to the shop</Link>
        </Button>
      </div>
    </main>
  );
}
